<template>
  <Row>
    <!-- 树形目录 -->
    <Col span="6">
      <Tree :data="treeData" @on-select-change="clickData"></Tree>
    </Col>
    <!-- 属性列表 -->
    <Col span="18">
      <div class="public-screen">
        <span>{{ currentName }}</span>
        <Button
          type="primary"
          icon="md-add"
          v-access="'attriInfo.add'"
          @click="dpOpenFn()"
          >添加属性</Button
        >
      </div>
      <Table border stripe :loading="loading" :columns="columns" :data="tbList">
        <template slot-scope="{ row, index }" slot="index">
          <span v-if="false">{{ row }}</span>
          {{ index + 1 }}
        </template>
        <template slot="parent">
          {{ currentName }}
        </template>
        <template slot-scope="{ row, index }" slot="status">
          <i-switch
            v-access="'attriInfo.status'"
            :value="row.status == 0"
            @on-change="(v) => stateChange(v, row, index)"
            size="small"
          />
        </template>
        <template slot-scope="{ row, index }" slot="action">
          <a
            href="javascript:;"
            v-access="'attriInfo.edit'"
            @click="dpOpenFn(row, index)"
            >编辑</a
          >
          <a
            href="javascript:;"
            v-access="'attriInfo.delete'"
            @click="removeFn(index, row)"
            >删除</a
          >
        </template>
      </Table>
    </Col>
    <!-- 单个属性 -->
    <Modal
      v-model="formModel"
      :title="formTitle == 0 ? '新增属性' : '编辑属性'"
      :loading="formModalLoading"
      :mask-closable="false"
      @on-ok="addAction"
      @on-cancel="cancelAction"
    >
      <Form ref="formValidate" :label-width="80">
        <FormItem>
          <span slot="label" class="public-require">名称</span>
          <Input v-model="name" placeholder="请输入属性名称"></Input>
        </FormItem>
        <FormItem>
          <span slot="label" class="public-require">列表</span>
          <Input v-model="addListContent" placeholder="请添加列表内容">
            <Button
              slot="append"
              icon="md-checkmark"
              @click="createItem"
            ></Button>
          </Input>
          <Row class="creat-list">
            <Col span="12" v-for="(item, index) in valueList" :key="index">
              <Input v-if="item.edit" v-model="temporaryValue">
                <template slot="append">
                  <Icon type="md-checkmark" @click="sureProperty(index)" />
                  <Icon
                    :style="{ marginLeft: '10px' }"
                    type="md-close"
                    @click="deleteProperty(index)"
                  />
                </template>
              </Input>
              <Input v-else :value="item.value" readonly>
                <template slot="append">
                  <Icon type="ios-create" @click="editProperty(index)" />
                  <Icon
                    :style="{ marginLeft: '10px' }"
                    type="md-close"
                    @click="deleteProperty(index)"
                  />
                </template>
              </Input>
            </Col>
          </Row>
        </FormItem>
        <FormItem>
          <span ref="brick" slot="label" class="public-require">所属分类</span>
          <Treeselect
            v-model="categoryCode"
            :data="selectData"
            text-field-name="name"
            value-field-name="code"
            size="small"
            placeholder="请选择所属分类"
          ></Treeselect>
        </FormItem>
      </Form>
    </Modal>
  </Row>
</template>
<script>
import Treeselect from "vue-treeselect";
const columns = [
  {
    title: "序号",
    slot: "index",
  },
  {
    title: "属性名称",
    key: "name",
  },
  {
    title: "所属分类",
    slot: "parent",
  },
  // {
  //   title: "属性级别",
  //   key: "level",
  // },
  {
    title: "状态",
    slot: "status",
  },
  {
    title: "操作",
    slot: "action",
    width: 150,
  },
];
export default {
  components: {
    Treeselect,
  },
  data() {
    return {
      treeData: [],
      selectData: [],
      columns,
      tbList: [],
      loading: false,
      currentName: "全部分类",
      currentCode: "",
      formModel: false,
      formTitle: "0",
      formModalLoading: true,
      addListContent: "",
      name: "",
      categoryCode: null,
      valueList: [],
      temporaryValue: "",
      updateCode: "0",
    };
  },
  created() {
    this.getTree();
    this.getList();
  },
  watch: {
    // tree选择后收起选项
    categoryCode(a, b) {
      this.$refs.brick.click();
    },
    deep: true,
  },
  methods: {
    getTree() {
      this.$api["categoryAll"]({}).then((res) => {
        if (res.code == "200") {
          let treeSt = {
            name: "全部分类",
            code: "",
            expand: true,
            parentCode: "-1",
          };
          let selectSt = {
            name: "全部分类(不可选)",
            code: "",
            opened: true,
            disabled: true,
            parentCode: "-1",
          };
          let list = [];
          let list1 = [];
          if (res.data && res.data.length > 0) {
            list = [...res.data, treeSt];
            list1 = [...res.data, selectSt];
          }
          this.treeData = this.tools.arrayToTree(list);
          this.selectData = this.tools.arrayToTree(list1, 1);
        }
      });
    },
    getList() {
      let data = { categoryCode: this.currentCode };
      this.loading = true;
      this.$api["propertySearch"](data).then((res) => {
        this.loading = false;
        if (res.code == "200") {
          this.tbList = res.data;
        } else {
          this.$Message.error("Fail!");
        }
      });
    },
    clickData(arr, item) {
      this.currentName = item.name;
      this.currentCode = item.code;
      this.$nextTick(() => {
        this.getList();
      });
    },
    // 删除属性
    removeFn(i, d) {
      let that = this;
      this.$Modal.confirm({
        title: "提示",
        content: `确认删除${d.name}`,
        okText: "确定",
        cancelText: "取消",
        onOk: async () => {
          let data = { code: d.code };
          that.$api.propertyDelete(data).then((res) => {
            if (res.code == "200") {
              that.getList();
            }
          });
        },
      });
    },
    // 打开属性
    dpOpenFn(d) {
      let that = this;
      this.formTitle = d ? 1 : 0;
      if (d) {
        this.name = d.name;
        this.updateCode = d.code;
        this.categoryCode = d.categoryCode;
        let list = d.valueList;
        let arr = list.map((item) => {
          return {
            ...item,
            edit: false,
          };
        });
        this.valueList = arr;
      }
      this.$nextTick(() => {
        that.formModel = true;
      });
    },
    createItem() {
      let word = this.addListContent;
      let list = this.valueList;
      if (word) {
        let obj = {
          value: word,
          edit: false,
        };
        this.valueList = list.concat([obj]);
        this.addListContent = "";
      }
    },
    editProperty(i) {
      this.valueList = this.valueList.map((item, index) => {
        if (index == i) {
          this.temporaryValue = item.value;
          item.edit = true;
        }
        return item;
      });
    },
    sureProperty(i) {
      this.valueList = this.valueList.map((item, index) => {
        if (index == i) {
          item.value = this.temporaryValue;
          item.edit = false;
        }
        return item;
      });
    },
    deleteProperty(i) {
      this.valueList.splice(i, 1);
    },
    // 确定属性
    addAction() {
      this.formModalLoading = false;
      this.$nextTick(() => {
        this.formModalLoading = true;
      });
      if (!this.name) {
        this.$Message.error("请输入属性名称");
        return;
      }
      let list = this.valueList;
      if (!list || list.length == 0) {
        this.$Message.error("请添加列表内容");
        return;
      }
      let nextAction = false;
      list.forEach((item) => {
        if (item.edit) {
          this.$Message.error("您有未确认的修改");
          nextAction = true;
        }
      });
      if (nextAction) {
        return;
      }
      if (!this.categoryCode) {
        this.$Message.error("请选择所属分类");
        return;
      }
      let array = list.map((item) => {
        let obj = { value: item.value };
        if (item.id) {
          obj.id = item.id;
        }
        return obj;
      });
      let data = {
        name: this.name,
        categoryCode: this.categoryCode,
        valueList: array,
      };
      let http = "propertyAdd";
      if (this.formTitle == 1) {
        data.code = this.updateCode;
        http = "propertyUpdate";
      }
      this.$api[http](data).then((res) => {
        if (res.code == "200") {
          this.$Message.success("操作成功");
          this.cancelAction();
          this.getList();
        }
      });
    },
    cancelAction() {
      this.name = "";
      this.categoryCode = null;
      this.valueList = [];
      this.$refs["formValidate"].resetFields();
      this.formModel = false;
    },
    // 状态
    stateChange(v, d, i) {
      let http = d.status == 0 ? "propertyDisable" : "propertyEnable";
      this.$api[http]({ code: d.code }).then((res) => {
        if (res.code == "200") {
          this.$Message.success(v ? "启用成功" : "禁用成功");
          this.getList();
        }
      });
    },
  },
};
</script>
<style scoped>
.creat-list {
  height: 150px;
  width: auto;
  overflow-y: scroll;
  border: 1px solid #ccc;
  border-radius: 4px;
  margin-top: 5px;
}
</style>



// WEBPACK FOOTER //
// src/views/commodity/attriInfo.vue